import * as Sentry from "@sentry/remix";
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import posthog from "posthog-js";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

Sentry.init({
  dsn: "https://f31bf6950400c8855c65ac9fa1faf7ee@o4508905675882496.ingest.us.sentry.io/4508905678241792",
  tracesSampleRate: 1,

  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
  ],
});

// AI search engines / chat assistants that send a referer when their users
// click through. Captured as a super-property so every PostHog event tags
// `ai_referrer` and you can segment all funnels by AI-driven traffic.
const AI_REFERRER_HOSTS: Array<{ match: string; label: string }> = [
  { match: "chat.openai.com", label: "chatgpt" },
  { match: "chatgpt.com", label: "chatgpt" },
  { match: "claude.ai", label: "claude" },
  { match: "perplexity.ai", label: "perplexity" },
  { match: "you.com", label: "you" },
  { match: "phind.com", label: "phind" },
  { match: "gemini.google.com", label: "gemini" },
  { match: "bing.com/chat", label: "bing_copilot" },
  { match: "copilot.microsoft.com", label: "bing_copilot" },
  { match: "kagi.com", label: "kagi" },
];

function detectAIReferrer(): string | null {
  if (typeof document === "undefined") return null;
  const referer = document.referrer || "";
  if (!referer) return null;
  const hit = AI_REFERRER_HOSTS.find((h) => referer.includes(h.match));
  return hit?.label ?? null;
}

function PosthogInit() {
  useEffect(() => {
    posthog.init("phc_rgcCi4bmdvigadDwg6hniurmf6BrjqMQr5z8tA2Yc7EF", {
      api_host: "https://pineapple.manupgame.com",
      person_profiles: "always",
      debug: process.env.NODE_ENV === "development",
    });

    const aiReferrer = detectAIReferrer();
    if (aiReferrer) {
      posthog.register({ ai_referrer: aiReferrer });
      posthog.capture("ai_referrer_landed", {
        ai_referrer: aiReferrer,
        referer: document.referrer,
        path: window.location.pathname,
      });
    }
  }, []);

  return null;
}
startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
      <PosthogInit />
    </StrictMode>
  );
});
